import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';
import { DraggableModalPanel } from './DraggableModalPanel';

type CollapsibleFormSectionProps = {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  editingSummary?: string;
  createSummary?: string;
  isEditing?: boolean;
  modalSubtitle?: string;
  className?: string;
  panelClassName?: string;
  /** Quando falso, só a janela do formulário é renderizada. O botão fica na página. */
  showTrigger?: boolean;
  children: ReactNode;
};

export function CollapsibleFormSection({
  title,
  expanded,
  onToggle,
  editingSummary,
  createSummary = 'Clique para cadastrar um novo item',
  isEditing = false,
  modalSubtitle,
  className = 'mb-6',
  panelClassName = 'w-full max-w-4xl',
  showTrigger = true,
  children,
}: CollapsibleFormSectionProps) {
  return (
    <>
      {showTrigger ? (
      <section
        className={`overflow-hidden rounded-xl border ${
          isEditing ? 'erp-form-card--editing' : 'border-secondary-200 bg-white'
        } ${className}`}
      >
        <button
          type="button"
          className="flex w-full items-start gap-2 px-4 py-3 text-left hover:bg-secondary-50"
          onClick={onToggle}
          aria-expanded={expanded}
        >
          {expanded ? (
            <ChevronDownIcon className="mt-0.5 h-4 w-4 shrink-0 text-secondary-500" />
          ) : (
            <ChevronRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-secondary-500" />
          )}
          <span className="min-w-0 flex-1">
            <span className="block text-lg font-semibold text-secondary-900">{title}</span>
            <span className="mt-0.5 block text-sm text-secondary-500">
              {isEditing
                ? (editingSummary ?? 'O formulário de edição abriu em uma janela')
                : createSummary}
            </span>
          </span>
        </button>
      </section>
      ) : null}

      <DraggableModalPanel
        open={expanded}
        title={title}
        subtitle={
          modalSubtitle
            ?? (isEditing ? 'Altere os dados e salve. Arraste a janela se precisar.' : undefined)
        }
        onClose={onToggle}
        className={`${panelClassName} ${isEditing ? 'erp-form-card--editing' : ''}`}
        bodyClassName="erp-card-body min-h-0 flex-1 overflow-y-auto"
      >
        {children}
      </DraggableModalPanel>
    </>
  );
}
